import { useCallback, useEffect } from 'react'

import { CaptchaAction } from './captcha'
import { Captcha } from './captchaHeaders'

/**
 * For the component that owns a captcha-protected submit: shows Google's badge, the required
 * notice, while mounted and `enabled`, and returns the call that mints the request's headers.
 * Disabled means no badge and no header, so a surface never mints without showing the notice.
 */
export const useCaptcha = (
  captcha: Captcha,
  action: CaptchaAction,
  enabled = true
) => {
  useEffect(
    () => (enabled ? captcha.showBadge(action) : undefined),
    [captcha, action, enabled]
  )

  return useCallback(
    async (): Promise<Record<string, string>> =>
      enabled ? captcha.getHeaders(action) : {},
    [captcha, action, enabled]
  )
}
